module.exports = __webpack_public_path__ + "static/Slide3-aaf3c2c0af366a2639dfeb07273959cd.jpg";